export const ESHOP_CATEGORY_TEST_ID = {
    CATEGORY_B2B_PAGE: 'category_b2b_page',
    CATEGORY_B2C_PAGE: 'category_b2c_page',
    CATEGORY_PAGE_TITLE: 'category-page-title',
    CATEGORY_SKELETON: 'category_skeleton',
    CATEGORY_PAGE_SORT_DROPDOWN: 'category-page-sort-dropdown',
    CATEGORY_PAGE_RESULTS_PRODUCTS: 'category-page-results-products',
    CATEGORY_COMPARE_BUTTON: 'category-compare-button',
    CATEGORY_COMPARE_REMOVE_ALL_BUTTON: 'category-compare-remove-all-button',
};
